<template>
  <div v-if="productHasMinOrderQuantity" class="c-gray-700 text-sm mt-md">
    {{ 'This product must be ordered in quantity of' | t }} {{ minOrderQuantity }}.
  </div>
</template>

<script>
import t from '../../js/main/i18n';

export default {
  name: 'SloMinOrderQuantityWarning',
  filters: {
    t
  },
  props: {
    minOrderQuantity: {type: String|Number, default: 1}
  },
  computed: {
    productHasMinOrderQuantity() {
      return this.minOrderQuantity > 1;
    }
  }
};
</script>
